import { useEffect, useRef, useState } from "react"

import { AppProvider } from "../../hooks/AppConext"

export const Context = ({ children }) => {
  const [hovered, setHovered] = useState(null)
  const [selected, setSelected] = useState(null)
  const [menuHovered, setMenuHovered] = useState(null)
  const [height, setHeight] = useState(0)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)
  const [camParams, setCamParams] = useState({})
  const dataProvider = {
    hovered,
    setHovered,
    selected,
    setSelected,
    isMobile,
    menuHovered,
    setMenuHovered,
    height,
    setHeight,
    camParams,
    setCamParams,
  }

  const handleResize = () => setIsMobile(window.innerWidth < 768)

  useEffect(() => {
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  })
  return <AppProvider value={dataProvider}>{children}</AppProvider>
}
